import { Injectable } from '@angular/core';
import { LMDialogButtonKey, LMUniqueIdService } from '@app/utils';
import { SohoModalDialogRef, SohoModalDialogService } from 'ids-enterprise-ng';
import { LMLargeImageIsDialogComponent } from './lm-large-image-is-dialog.component';
import { LMErrorUtilService, LMUrlUtilService } from '@app/services';
import { catchError, first } from "rxjs/operators";
import { throwError } from "rxjs";
import { LMFormRequestService } from "@form/services";

@Injectable()
export class LMLargeImageIsDialogService {
  private largeImageModal: SohoModalDialogRef<any> | undefined;

  constructor(
    private lmUniqueIdService: LMUniqueIdService,
    private lmUrlUtilService: LMUrlUtilService,
    private sohoModalDialogService: SohoModalDialogService,
    private lmFormRequestService: LMFormRequestService,
    private lmErrorUtilService: LMErrorUtilService
  ) { }

  public openLargeImageDialog(largeImage: LMLargeImageIsInfo) {
    const dialogId = 'large-image-is';

    const buttons: SohoModalButton[] = [
      {
        id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CLOSE ]),
        text: Soho.Locale.translate(LMDialogButtonKey.CLOSE),
        click: (e, modal) => {
          this?.largeImageModal?.close(LMDialogButtonKey.CLOSE);
        },
      }
    ];

    if (largeImage.download) {
      let downloadUrl = largeImage.download.downloadUrl;

      if (largeImage.download.formRequestUrl) {
        const requestUrl = largeImage.download.formRequestUrl;
        const fieldId = largeImage.download.fieldId as string;

        this.lmFormRequestService.getFieldValues(requestUrl, [ fieldId ]).pipe(
          first(),
          catchError( error => throwError(error || 'Internal Server Error'))
        ).subscribe( (response: LMFieldValuesResponse) => {
          if (response.status === 'Completed') {
            downloadUrl = response.fields[fieldId].blobUrl;
          } else if (response.status === 'Exception') {
            this.lmErrorUtilService.handleError(response?.message as string, response?.details, response.status);
          }
        });
      }

      buttons.push({
        id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.DOWNLOAD ]),
        text: Soho.Locale.translate(LMDialogButtonKey.DOWNLOAD),
        click: (e, modal) => {
          const downloadLink = document.getElementById('largeImageIsDownload');
          if (!downloadLink) {
            return;
          }

          const url = this.lmUrlUtilService.removeParam(downloadUrl as string, 'size');
          downloadLink.setAttribute('href', `${url}`);
          downloadLink.setAttribute('download', `${largeImage?.title}`);
          downloadLink.click();
        },
        isDefault: true
      });
    }

    const title = largeImage?.title as string;
    const attributes: SohoAttributesArray = [ { name: 'data-automation-id', value: `lm-large-image-is-modal` } ];
    const options: SohoModalOptions = {
      fullsize: 'responsive',
      showCloseBtn: false,
      attributes
    };

    this.largeImageModal = this.sohoModalDialogService
      .modal(LMLargeImageIsDialogComponent)
      .options(options)
      .buttons(buttons)
      .title(title)
      .apply((component: LMLargeImageIsDialogComponent) => {
        component.imageUrl = this.getImageUrl(largeImage);
      })
      .open();
  }

  // Remove size for LargeImageIs, show original size in modal
  private getImageUrl(largeImage: LMLargeImageIsInfo): string {
    const imageUrl = largeImage?.imgUrl ? largeImage.imgUrl : '';
    return this.lmUrlUtilService.removeParam(imageUrl as string, 'size');
  }
}